import { render, staticRenderFns } from "./VTimer.vue?vue&type=template&id=59c534b1&scoped=true"
import script from "./VTimer.vue?vue&type=script&lang=ts"
export * from "./VTimer.vue?vue&type=script&lang=ts"
import style0 from "./VTimer.vue?vue&type=style&index=0&id=59c534b1&prod&lang=scss&scoped=true"
import style1 from "./VTimer.vue?vue&type=style&index=1&id=59c534b1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c534b1",
  null
  
)

export default component.exports